import React from 'react';
import { CardMedia } from '@mui/material';
import defaultDeckImage from '../assets/default-deck.png';

function DeckImage({ imageUrl, name }) {
  const getImageUrl = (url) => {
    if (!url) return defaultDeckImage;
    const baseUrl = process.env.REACT_APP_API_URL.replace(/\/api$/, '');
    return `${baseUrl}${url}`;
  };

  return (
    <CardMedia
      component="img"
      height="140"
      image={getImageUrl(imageUrl)}
      alt={name}
      sx={{
        objectFit: 'cover',
        backgroundColor: '#f5f5f5'
      }}
    />
  );
}

export default DeckImage; 